import { docIcon2, dropdownIcon, locationSearchIcon } from "assets/icons";
import React from "react";
import { Link } from "react-router-dom";
import MySites from "../mySites/MySites";

const DocumentRepository = () => {
  return (
    <MySites
      title="Document Repository"
      cardIcon={docIcon2}
      navigate='/document-repository/folders'
    />
  );
};

export default DocumentRepository;
